exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-custom{margin-top:50px!important;margin-bottom:70px!important}.max-md-hidden{@media (max-width:767px){display:none}}.md-hidden{@media (min-width:768px){display:none}}", ""]);

// exports
